export const accessTemplate = [
  {
    label: '材料费用',
    prop: 'material-cost',
    component: 'cost-clfy',
    version: 'cost-clfy_3_1',
    $component: '成本-材料费用',
    $version: 'cost-clfy_3_1',
    $index: 0
  },
  {
    label: '外协外购',
    prop: 'outsocring',
    component: 'cost-wxwg',
    version: 'cost-wxwg_1_2',
    $component: '成本-外协外购',
    $version: 'cost-wxwg_1_2',
    $index: 1
  },
  {
    label: '机台费用',
    prop: 'machine-cost',
    component: 'cost-jtfy',
    version: 'cost-jtfy_1_1',
    $component: '成本-机台费用',
    $version: 'cost-jtfy_1_1',
    $index: 2
  },
  {
    label: '装配人工费',
    prop: 'fit-rate',
    component: 'cost-fitout',
    version: 'cost-fitout_1_1',
    $component: '成本-装配人工费用',
    $version: 'cost-fitout_1_1',
    $index: 3
  },
  {
    label: '其他',
    prop: 'other',
    component: 'cost-other',
    version: 'cost-other_1_1',
    $component: '成本-其他',
    $version: 'cost-other_1_1',
    $index: 4
  },
  {
    label: '包装费用',
    prop: 'package-cost',
    component: 'cost-package',
    version: 'cost-package_1_1',
    $component: '成本-包装费用',
    $version: 'cost-package_1_1',
    $index: 5
  },
  {
    label: '运输费用',
    prop: 'freight',
    component: 'cost-freight',
    version: 'cost-freight_1_2',
    $component: '成本-运输费',
    $version: 'cost-freight_1_2',
    $index: 6
  },
  {
    label: '专项费用',
    prop: 'Special-cost',
    component: 'cost-special',
    version: 'cost-special_1_1',
    $component: '成本-专项费用',
    $version: 'cost-special_1_1',
    $index: 7
  },
  {
    label: '测试新tab',
    prop: 'testNewTab',
    component: 'cost-other',
    version: 'cost-other_2_1',
    $component: '成本-其他',
    $version: 'cost-other_2_1',
    $index: 8
  }
];
